import { useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { getMasterVolume, setMasterVolume } from "../lib/sounds";
import { useLang } from "../i18n";

// Toggle suoni + barra del volume (condivisa da pagina giveaway e ruota).
export function SoundControls({ soundOn, onToggle, compact = false }) {
  const { t } = useLang();
  const [vol, setVol] = useState(() => Math.round(getMasterVolume() * 100));

  return (
    <div className="flex items-center gap-3" data-testid="sound-controls">
      <button
        onClick={onToggle}
        data-testid="giveaway-sound-toggle"
        title={soundOn ? t("gv.sound_off") : t("gv.sound_on")}
        aria-label={soundOn ? t("gv.sound_off") : t("gv.sound_on")}
        className="text-steel hover:text-wardogs transition-colors duration-300"
      >
        {soundOn ? <Volume2 className="w-4 h-4" /> : <VolumeX className="w-4 h-4" />}
      </button>
      <input
        type="range"
        min="0"
        max="100"
        value={vol}
        data-testid="giveaway-volume-slider"
        title={t("gv.volume")}
        aria-label={t("gv.volume")}
        onChange={(e) => {
          const v = Number(e.target.value);
          setVol(v);
          setMasterVolume(v / 100);
        }}
        className={`${compact ? "w-20" : "w-24"} h-1 accent-[#FF5C00] cursor-pointer`}
      />
      <span className="font-mono text-[9px] text-[#4A4D51] w-7 text-right">{vol}%</span>
    </div>
  );
}
